import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { CreateOpportunityDTO } from '@modules/opportunities/entities/opportunity/api/dto/createOpportunity.dto';
import { t } from 'i18next';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

const useCreateOpportunity = () => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['createOpportunity'],
    mutationFn: (body: CreateOpportunityDTO | CreateOpportunityDTO<'ES'>) =>
      opportunitiesApi.createOpportunity(body),
    onSuccess: (data) => {
      // Track success
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_CREATION_COMPLETED, {
        useContext: true,
        case_id: data.opportunity_external_id,
        client_id: data.client_external_id ?? null,
      });
      queryClient.invalidateQueries({ queryKey: ['clientOpportunity', data.opportunity_external_id] });
      queryClient.invalidateQueries({ queryKey: ['listAllOpportunities'] });
    },
    onError: (errors) => {
      // Track fail
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_CREATION_FAILED, {
        useContext: true,
        error_message: errors,
      });
      toast('error', { message: t('opportunity.mutations.createOpportunityFailed') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useCreateOpportunity;
